function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Wifi_svg__clip0)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, React.createElement("path", {
  d: "M24 33a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm-7.5 4.5A7.5 7.5 0 0124 30a7.5 7.5 0 017.5 7.5A7.5 7.5 0 0124 45a7.5 7.5 0 01-7.5-7.5zm-4.173-11.667c6.444-6.443 16.89-6.443 23.334 0a1.5 1.5 0 11-2.122 2.122c-5.272-5.273-13.818-5.273-19.09 0a1.5 1.5 0 01-2.122-2.122z"
}), React.createElement("path", {
  d: "M5.97 19.47c9.957-9.958 26.103-9.958 36.06 0a1.5 1.5 0 11-2.12 2.12c-8.787-8.786-23.033-8.786-31.82 0a1.5 1.5 0 11-2.12-2.12z"
}), React.createElement("path", {
  d: "M.477 12.265c13.25-12.351 33.796-12.351 47.046 0a1.5 1.5 0 11-2.046 2.194C33.38 3.182 14.621 3.182 2.523 14.46a1.5 1.5 0 11-2.046-2.194z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Wifi_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgWifi(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgWifi;